import React, { Component } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import queryString from "app/services/queryStringService";
import _ from "lodash";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Button, Form, Tooltip } from "react-bootstrap";
import { MdDelete } from "react-icons/md";
import moment from "moment";
import DateModal from "./Components/List/DateModal";
import EditModal from "./Components/List/EditModal";
import { AiFillFileExcel } from "react-icons/ai";

import config from "config.json";
import Swal from "sweetalert2";
import { NotificationManager } from "react-notifications";
import {
  getCharterFlightById,
  deleteCharter,
  deleteCharterRow,
  exportList,
  actionCharterFlight,
  getcharterRequest,
} from "./Components/Service/CharterService";
import { useState } from "react";
import { useEffect } from "react";

const { timeFormat, dateFormat } = config;

function CharterFlightList() {
  const [state, setState] = useState({
    showPassenger: false,
    showTicketModal: false,
    ticketData: {},
    page: 1,
    data: [],
    sizePerPage: 10,
    dataCount: 0,
    loading: true,
    showDateModal: false,
    dateModalDetails: [],
    selectedId: 0,
    showEditModal: false,
    flightData: [],
  });

  const getFligtById = async () => {
    const charterResponse = await getCharterFlightById(state.selectedId);
    setState((prev) => ({ ...prev, dateModalDetails: charterResponse.data }));
  };

  const getDateDetails = async (cell, row) => {
    setState((prev) => ({ ...prev, selectedId: row.id, showDateModal: true }));

    //

    const charterResponse = await getCharterFlightById(row.id);
    setState((prev) => ({ ...prev, dateModalDetails: charterResponse.data }));
    // window.setTimeout(async () => {
    //   await getFligtById();
    // }, 1);
  };
  const handleEdit = async (selectedDate) => {
    // console.log( state.dateModalDetails);
    // const flightResponse = await getCharterFlightById( state.selectedId);

    setState((prev) => ({
      ...prev,
      showEditModal: !state.showEditModal,
      //showDateModal: ! state.showDateModal,
    }));
    const flightData = state.dateModalDetails?.charterFlights.filter(
      (item) => new moment(item.flightDate).format("YYYY-MM-DD") == selectedDate
    )[0];
    setState((prev) => ({ ...prev, flightData }));
  };

  const handleDelete = async (selectedId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const charterResponse = await deleteCharter(selectedId);
        if (charterResponse.status === "Success") {
          window.setTimeout(async () => {
            await getFligtById();
          }, 1);
          Swal.fire("Deleted!", "Your data has been deleted.", "success");
        } else {
          Swal.fire("Deleted!", charterResponse.message, "success");
        }
      }
    });
  };

  const updateStatus = async (row) => {
    Swal.fire({
      title: `Are you sure you want to
      ${!row.isDisabled == true ? "inactive" : "active"}
       the Charter Flight?`,
      icon: "warning",
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
    }).then(async (result) => {
      if (result.value) {
        const requestData = { id: row.id, status: !row.isDisabled };

        const res = await actionCharterFlight(requestData);

        try {
          if (res.status === "Success") {
            NotificationManager.success(res.message);
          } else {
            NotificationManager.error(res.message);
          }
          setTimeout(async () => {
            await loadCharterHistory();
          }, 10);
        } catch (error) {
          NotificationManager.error(error);
        }
      } else {
        Swal.fire({
          title: "Cancelled!",
          text: "Permission denied.",
          type: "error",
          icon: "error",
          timer: 1500,
        });
      }
    });
  };

  const deleteRow = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const charterResponse = await deleteCharterRow(id);
        console.log(charterResponse);
        if (charterResponse.status === "Success") {
          // window.setTimeout(async () => {
          //   await  getFligtById();
          // }, 1);
          Swal.fire("Deleted!", "Your data has been deleted.", "success");
          setState((prev) => ({ ...prev, page: 1 }));
          await loadCharterHistory();
        } else {
          Swal.fire("Deleted!", charterResponse.message, "error");
        }
      }
    });
  };

  const departTimeFormatter = (cell, row) => {
    return moment(row.departureTime, "hh:mm:ss").format(timeFormat);
  };

  const arrivalTimeFormatter = (cell, row) => {
    return moment(row.arrivalTime, "hh:mm:ss").format(timeFormat);
  };
  const actionFormatter = (cell, row) => {
    return (
      <div
        className="d-flex justify-content-center"
        style={{
          float: "",
          cursor: "pointer",
        }}
      >
        <div className="row">
          <div className="col mt-3 text-center ml-3">
            <span>
              <Form.Check
                type="switch"
                id={`custom-switch${row.id}`}
                checked={!row.isDisabled ? true : false}
                onChange={() => updateStatus(row)}
              />
            </span>
          </div>
        </div>
      </div>
    );
  };
  const deleteFormatter = (cell, row) => {
    return (
      <button className="btn btn-link">
        <MdDelete
          className="text-danger cursor-pointer"
          size={20}
          onClick={() => deleteRow(row.id)}
        />
      </button>
    );
  };

  const DateFormatter = (cell, row) => {
    const dates = row.dates.split("|");
    if (dates.length > 1) {
      return (
        <>
          <span>
            {moment(dates[0]).format(dateFormat)} to
            {moment(dates[dates.length - 1]).format(dateFormat)}
          </span>
          <br />
          <Button
            variant="link"
            size="sm"
            onClick={(e) => getDateDetails(e, row)}
          >
            View Dates
          </Button>
        </>
      );
    } else {
      return (
        <>
          <span>{dates[0]}</span> <br />
          <Button
            variant="link"
            size="sm"
            onClick={(e) => getDateDetails(e, row)}
          >
            View Date
          </Button>
        </>
      );
    }
  };

  const handleDateClose = () => {
    setState((prev) => ({ ...prev, showDateModal: false }));
  };

  const EditModalClose = () => {
    setState((prev) => ({ ...prev, showEditModal: false }));
  };
  const columns = [
    {
      dataField: "tripType",
      text: "Trip Type",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDeparture.cityCode",
      text: "From",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "airportDestination.cityCode",
      text: "To",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "dates",
      text: "Dates",
      headerStyle: (colum, colIndex) => {
        return { width: "200px", textAlign: "center" };
      },
      formatter: DateFormatter,
    },
    {
      dataField: "pnr",
      text: "Pnr",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "departureTime",
      text: "Departure Time",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: departTimeFormatter,
    },
    {
      dataField: "arrivalTime",
      text: "Arrival Time",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: arrivalTimeFormatter,
    },
    {
      dataField: "id",
      text: "Delete",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: deleteFormatter,
    },

    {
      dataField: "row.id",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];
  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };
  const NoDataIndication = () => {
    const { loading } = state;
    //alert(loading);
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };

  const loadCharterHistory = async () => {
    const { page, sizePerPage } = state;
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
    });
    if (state.dataCount !== 0) {
      setState((prev) => ({ ...prev, loading: true }));
    }

    const response = await getcharterRequest(query);

    const data = response.data.data;
    // console.log(data);

    const paggingData = JSON.parse(response.headers["x-pagination"]);

    setState((prev) => ({
      ...prev,
      loading: false,
      data,
      dataCount: paggingData.TotalCount,
      page: paggingData.CurrentPage,
      sizePerPage: paggingData.PageSize,
    }));
  };

  useEffect(() => {
    loadCharterHistory();
  }, []);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    const currentIndex = (page - 1) * sizePerPage;
    setState((prev) => ({ ...prev, page, sizePerPage }));
    setTimeout(async () => {
      await loadCharterHistory();
    }, 10);
  };
  const setShowEditModal = () => {
    setState((prev) => ({
      ...prev,
      showEditModal: !state.showEditModal,
      showDateModal: !state.showDateModal,
    }));
  };

  const handleSearch = async () => {
    setState((prev) => ({ ...prev, page: 1, sizePerPage: 10 }));

    setTimeout(async () => {
      await loadCharterHistory();
    }, 10);
  };

  const exportListHandler = async () => {
    const { page, sizePerPage } = state;
    const query = queryString.getQueryStringFromObj({});
    if (state.dataCount !== 0) {
      setState((prev) => ({ ...prev, loading: true }));
    }

    const response = await exportList(query);
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `_charterList.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setState((prev) => ({ ...prev, loading: false }));
  };

  const handleExport = async () => {
    setState((prev) => ({ ...prev, page: 1, sizePerPage: 10 }));

    setTimeout(async () => {
      await exportListHandler();
    }, 10);
  };

  const { data, sizePerPage, page, dataCount, loading } = state;

  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };

  return (
    <>
      <Link
        className="btn btn-primary btn-md float-end"
        to="/supplier/flight/add"
      >
        <i className="i-Add-User text-white mr-2"></i> Create Charter
      </Link>
      <Helmet>
        <title>Charter Flight Request</title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Charter Flight Request" }]}
      ></Breadcrumb>
      <div className="d-flex flex-row-reverse">
        <Button
          variant="outline-primary"
          className="mr-3 mb-2"
          onClick={handleExport}
        >
          Export Excel
          <AiFillFileExcel className="" />
        </Button>
      </div>
      <div>
        <BootstrapTable
          hover
          remote
          keyField="id"
          data={data}
          columns={columns}
          pagination={paginationFactory(paginationOptions)}
          onTableChange={handleTableChange}
          noDataIndication={() => <NoDataIndication />}
          headerClasses="bg-primary text-white"
          bodyClasses="react-bootstrap-table-next-min-height"
          rowStyle={rowStyle}
        />
      </div>
      <DateModal
        showDateModal={state.showDateModal}
        handleClose={handleDateClose}
        selectedId={state.selectedId}
        dateModalDetails={state.dateModalDetails}
        setShowEditModal={setShowEditModal}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        showEditModal={state.showEditModal}
      />
      <EditModal
        refreshData={getFligtById}
        showEditModal={state.showEditModal}
        selectedId={state.selectedId}
        EditModalClose={EditModalClose}
        flightData={state.flightData}
      />
    </>
  );
}
export default CharterFlightList;
